import React from 'react';
import styled from 'styled-components';
import {
  accountSelectionListId,
  IA2AccountDropdownSearchInput,
} from './styles';
import { FlexBox, FlexContainer } from 'src/commons/components/FlexContainer';
import { useAccountDropdownSearch } from './useAccountDropdownSearchAndFilter';
import { IA2AccountDropdownTypeSection } from './IA2AccountDropdownTypeSection';
import { IA2AccountDropdownInfoCard } from './IA2AccountDropdownInfoCard';
import { IA2MobileAccountDropdownFilterInput } from './IA2MobileAccountDropdownFilterInput';
import { useAccountDropdownContext } from './AccountDropdownProvider';
import { IA2AccountFilteredMessage } from './IA2AccountFilteredMessage';
import { IA2AccountDropdownFooterLinks } from './IA2AccountDropdownFooterLinks';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { getAccountTypeListLabel } from './AccountTypeLocalizationKeyMapping';
import { ErrorLoadingAccountsMessage } from 'src/features/header/components/AccountDropdown/ErrorLoadingAccountsMessage';
import { NoAccountsMessage } from 'src/features/header/components/AccountDropdown/NoAccountsMessage';

const AccountSwitcherContainer = styled.div``;

const MobileAccountListContainer = styled.div`
  flex: 1;
  position: relative;
  padding: 0 ${({ theme }) => theme.spacing.base};
  border-top: 1px solid rgb(231, 231, 231);
`;

const AccountDropdownWithSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SearchAndFilterContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.base};
`;

const SEARCH_AND_FILTER_DISPLAY_COUNT = 10;

export const IA2MobileAccountDropdown: React.VFC = () => {
  const { accounts, accountTypeCounter, accountCounter, loadingStatus } =
    useAccountDropdownContext();

  const bundle = useAccountDropdownBundle();
  const {
    onSearch,
    accountTypeList,
    accountTypeFilterList,
    onFilter,
    onClear,
    searchValue,
  } = useAccountDropdownSearch({
    accounts,
  });
  const isFailedLoadingAccountData = loadingStatus === 'error';

  const searchAccountPlaceholder = bundle.getMessage(
    'account-dropdown-placeholder',
  );

  return (
    <AccountDropdownWithSearchContainer data-ccx-e2e-id="aac-mobile-account-dropdown-wrapper">
      <AccountSwitcherContainer>
        <IA2AccountDropdownInfoCard />
        {accountCounter > SEARCH_AND_FILTER_DISPLAY_COUNT && (
          <SearchAndFilterContainer>
            <FlexContainer>
              <FlexBox flex={1}>
                <IA2AccountDropdownSearchInput
                  id="account-switcher-search"
                  placeholder={searchAccountPlaceholder}
                  onChange={onSearch}
                  onClear={onClear}
                  fullWidth={true}
                  label={searchAccountPlaceholder}
                  value={searchValue}
                />
              </FlexBox>
              {accountTypeCounter > 1 && (
                <IA2MobileAccountDropdownFilterInput
                  accountTypes={accountTypeFilterList}
                  onSubmit={onFilter}
                />
              )}
            </FlexContainer>
            {accountTypeFilterList.some((filter) => !filter.isSelected) && (
              <IA2AccountFilteredMessage accountTypeList={accountTypeList} />
            )}
          </SearchAndFilterContainer>
        )}
      </AccountSwitcherContainer>
      <MobileAccountListContainer id={accountSelectionListId}>
        {isFailedLoadingAccountData && <ErrorLoadingAccountsMessage />}
        {!isFailedLoadingAccountData && accountTypeList.length === 0 && (
          <NoAccountsMessage />
        )}
        {!isFailedLoadingAccountData &&
          accountTypeList.length > 0 &&
          accountTypeList.map((accountTypeItem) => {
            return (
              <IA2AccountDropdownTypeSection
                key={accountTypeItem.accountType}
                accounts={accountTypeItem.accounts}
                label={getAccountTypeListLabel(
                  accountTypeItem.accountType,
                  bundle,
                )}
                type={accountTypeItem.accountType}
              />
            );
          })}
      </MobileAccountListContainer>
      <IA2AccountDropdownFooterLinks />
    </AccountDropdownWithSearchContainer>
  );
};
